export default "__VITE_ASSET__KQl65OcR__"